"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
/**
* Nom : error.js
* Description : Ce fichier contient la définition de la page error 
*               Cette page affiche un message quand la page demandée n'existe pas
* Date de création : 30 septembre 2025
*/

/* CSS et assets */
/*import 'package_ui_ihm/styles/App.css';
import 'package_ui_ihm/styles/Container.css';*/

/* Bibliothèques et composants */

/* Hook */

/**
* Error : affiche une page avec un message quand la page demandée n'existe pas
*
* Type : page 
*
* Parametres : 
*  None
*/function Error() {
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: screenWidth > 650 ? 'App' : 'App-ss',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        children: "Oups vous vous \xEAtes perdu dans la nature"
      })
    })
  });
}
var _default = exports["default"] = Error;